<template lang="pug">
.careimage-modal
  b-modal(ref="modal" size="xl" no-close-on-backdrop no-close-on-esc hide-footer)
    template(#modal-header="{ cancel }")
      .careimage-modal-header
        span.float-left.title {{ title }}
        .float-right
          button.btn.index-btn(v-for="(imageUrl, index) in imageUrls" type="button" :class="isSelected(index)" @click="selectImage(index)") {{ index + 1 }}
          button.btn.trash-btn(v-if="canDelete && showDelete" type="button" @click="onDelete()")
            .trash-icon
      button.close(type="button" @click="cancel") ×
    .careimage-modal-body
      img(:src="imageUrl")
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * 介護記録モーダル
 *
 */
@Component
export default class CareimageModal extends Vue {
  /** 削除ボタン表示可否 */
  @Prop({
    default: () => {
      return false;
    }
  })
  private showDelete!: boolean;

  /**
   * タイトル
   * このコンポーネントは画面専用で汎用的に作る必要がないため、
   * 画面表示内容は表示時に渡す
   */
  private title: string = "";
  /** 削除ボタンを押下できるかどうか */
  private canDelete: boolean = false;
  /** 画像URL */
  private imageUrls: Array<string> = [];
  /** 選択している画像のindex */
  private selected: number = 0;
  /** 表示画像 */
  private imageUrl: string = "";

  /**
   * 画像表示ボタンのスタイルを返す
   *
   * 選択している画像のインデックスと比較して、選択している画像であれば強調表示用のスタイルを返す
   *
   * @params index ボタンのインデックス
   */
  private isSelected(index: number): string {
    if (this.selected == index) {
      return "selected";
    } else {
      return "";
    }
  }

  /**
   * モーダル表示
   *
   * このコンポーネントは表示・非表示を繰り返すので、表示するタイミングで全体的な初期化処理を行う
   * 同じ理由で、モーダルのタイトルと表示内容も表示時に渡す
   *
   * @param title モーダルタイトル
   * @param careimage モーダル表示する介護記録
   */
  public show(title: string, canDelete: boolean, imageUrls: Array<string>) {
    // 初期化
    this.title = title;
    this.canDelete = canDelete;
    this.imageUrls = imageUrls;

    // 画面表示対象の画像を初期化
    this.selected = 0;
    this.imageUrl = this.imageUrls[this.selected];

    // 画面遷移等でモーダルのインスタンスがなくなってしまっている場合がある、存在する場合のみモーダルを表示する
    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }

    return;
  }

  /**
   * モーダルの非表示
   */
  public hide() {
    const modal: any = this.$refs.modal;
    if (modal) {
      modal.hide();
    }

    return;
  }

  /**
   * 画像表示ボタン押下イベント
   */
  private selectImage(index: number) {
    this.selected = index;
    // 画像切替えタイミングでimg要素がGETをかけている間、もう片方の画像がキャッシュされて表示されてしまう
    // ローディングを出せるように見直しすべき
    this.imageUrl = this.imageUrls[this.selected];

    return;
  }

  /**
   * 介護記録削除ボタン押下イベント
   *
   * 親コンポーネントに削除ボタンが押下されたことを通知する
   * このコンポーネントで削除ボタンが押下された際の画面仕様はこのコンポーネントで持つべきではない
   * そのため、親コンポーネントに通知を出すまでがこのコンポーネントの責務となる
   */
  private onDelete() {
    this.$emit("on-delete");

    return;
  }
}
</script>
<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.trash-btn {
  height: 42px !important;
  padding: 2px 5px !important;
  .trash-icon {
    @include svg-icon("../../../assets/trash.svg", $font-base-color, 24px, 24px);
  }
}
</style>
